import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { getErrorMessage } from '../types';
import { useTranslation } from '../i18n';

/**
 * Stripe redirects here when an Account Link expires before the user finishes onboarding.
 * We immediately ask the backend for a fresh link and redirect the browser to it.
 */
export const AccountPayoutsRefreshPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const refresh = async () => {
      try {
        const res = await api.post<{ url: string }>('/connect/onboarding-link');
        if (cancelled) return;
        window.location.href = res.data.url;
      } catch (err) {
        if (cancelled) return;
        setError(getErrorMessage(err, t('connect.refresh_error')));
      }
    };
    void refresh();
    return () => { cancelled = true; };
  }, [t]);

  const handleReturnBack = () => {
    navigate('/account?tab=owner');
  };

  return (
    <div>
      <h2 className="section-title">{t('connect.refresh_title')}</h2>
      {error ? (
        <>
          <div className="alert alert-error">{error}</div>
          <button type="button" className="btn btn-primary" onClick={handleReturnBack}>
            {t('connect.return_back')}
          </button>
        </>
      ) : (
        <p className="text-muted">{t('connect.refresh_message')}</p>
      )}
    </div>
  );
};
